import React from "react";

const Layout = ({ children }) => {
  return <div className="wrapper">{children}</div>;
};

export default Layout;
